// extracted by mini-css-extract-plugin
module.exports = {"image":"DeliciousRewards_image__32CU-"};